document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.getElementById('CartDrawer');
  if (!cartDrawer) return;

  let cartOpen = false;

  function findSmileLauncher() {
    return document.querySelector(
      '[id*="launcher-frame-container"], [class*="smile-launcher-frame-container"]'
    );
  }

  function applySmileState() {
    const el = findSmileLauncher();
    if (!el) return;
    if (cartOpen) {
      if (el.style.display !== 'none') {
        el.style.setProperty('display', 'none', 'important');
      }
    } else {
      el.style.removeProperty('display');
    }
  }

  const bodyObserver = new MutationObserver(function () {
    if (cartOpen) applySmileState();
  });
  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });

  cartDrawer.addEventListener('toggle', function () {
    cartOpen = cartDrawer.hasAttribute('open');
    applySmileState();
  });
});